import React, { useState, useGlobal } from "reactn";
import PropTypes from "prop-types";

// components
import PageText from "../../../_common/pageText/PageText.styled";

// styled components
import { EditableBlock } from "./EditableBlock.styled";

const EditableBlockWrapper = ({ config, title, form, errors }) => {
  const [blockSummary, setBlockSummary] = useState(true);

  const [values] = useGlobal("values");

  // This returns a subset of values based on a list of keys passed in.
  const subset = (keys, obj) => {
    return keys.map(item => ({ fieldName: item, fieldValue: obj[item] }));
  };

  config = Object.values(subset(config, values));

  const editBlock = () => {
    // show editableFields
    setBlockSummary(false);
  };

  const saveBlock = () => {
    // Only Save block if there are no errors.
    if (Object.getOwnPropertyNames(errors).length < 1) {
      setBlockSummary(true);
    }
  };
  return (
    <EditableBlock>
      <div className="block">
        <PageText>{title}</PageText>

        {blockSummary ? (
          <>
            {config.map(data => (
              <div>
                <p key={data.fieldName}>{data.fieldValue}</p>
                <input
                  type="hidden"
                  name={data.fieldName}
                  key={data.fieldName}
                  value={data.fieldValue}
                />
              </div>
            ))}
          </>
        ) : (
            <>{form}</>
          )}
        <div className="iconWrapper">
          {blockSummary ? (
            <div className="flex">
            <button type="button" onClick={editBlock}>
              <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M.015 11.25L0 14.335c0 .174.06.349.178.475.118.127.266.19.429.19l2.87-.016c.164 0 .312-.063.43-.19l9.915-10.601a.702.702 0 0 0 0-.934L10.981.19a.597.597 0 0 0-.873 0L8.125 2.327.192 10.79a.73.73 0 0 0-.177.459zm10.537-9.668l1.998 2.136-1.125 1.203-1.998-2.136 1.125-1.203zm-9.309 9.953l7.31-7.817 1.999 2.136-7.311 7.801-2.013.016.015-2.136zM17.358 17c.351 0 .642.232.642.5s-.275.5-.627.5H.627C.291 18 0 17.768 0 17.5s.275-.5.627-.5h16.73z"
                  fill="#008755"
                  fillRule="nonzero"
                ></path>
              </svg>
              <span>
                Edit
              </span>
            </button>
            </div>
          ) : (
            <div className="flex">
              <button type="button" onClick={saveBlock}>
                <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M.015 11.25L0 14.335c0 .174.06.349.178.475.118.127.266.19.429.19l2.87-.016c.164 0 .312-.063.43-.19l9.915-10.601a.702.702 0 0 0 0-.934L10.981.19a.597.597 0 0 0-.873 0L8.125 2.327.192 10.79a.73.73 0 0 0-.177.459zm10.537-9.668l1.998 2.136-1.125 1.203-1.998-2.136 1.125-1.203zm-9.309 9.953l7.31-7.817 1.999 2.136-7.311 7.801-2.013.016.015-2.136zM17.358 17c.351 0 .642.232.642.5s-.275.5-.627.5H.627C.291 18 0 17.768 0 17.5s.275-.5.627-.5h16.73z"
                    fill="#008755"
                    fillRule="nonzero"
                  ></path>
                </svg>
                <span>
                  Save
                </span>
            </button>
            </div>
            )}
        </div>
      </div>
    </EditableBlock>
  );
};

export default EditableBlockWrapper;

// props
EditableBlockWrapper.propTypes = {
  config: PropTypes.array.isRequired,
  title: PropTypes.string,
  form: PropTypes.any,
  errors: PropTypes.object
};
